<script lang="ts" setup>
import CheckList from "@/components/CheckList.vue";
import CtaBanner from "@/components/CtaBanner.vue";
import CtaButton from "@/components/CtaButton.vue";

const { t } = useI18n();

const checklistItems = [
  t("startPage.ctaBanner.simpleAndSecure.checklist.1"),
  t("startPage.ctaBanner.simpleAndSecure.checklist.2"),
  t("startPage.ctaBanner.simpleAndSecure.checklist.3"),
];
</script>

<template>
  <CtaBanner class="cta-banner-simple-and-secure" :direction-row="true">
    <div class="cta-banner-simple-and-secure__image">
      <img
        src="@/images/cta_banner/simple-and-secure.svg"
        alt="simple-and-secure"
        loading="lazy"
      />
    </div>
    <div class="cta-banner-simple-and-secure__text">
      <h2 class="mb-4 cta-banner-simple-and-secure__title">
        {{ t("startPage.ctaBanner.simpleAndSecure.title") }}
      </h2>

      <p
        v-safe-html="t('startPage.ctaBanner.simpleAndSecure.text')"
        class="cta-banner-simple-and-secure__content"
      />

      <CheckList :items="checklistItems" />

      <p class="mb-5 cta-banner-simple-and-secure__content">
        <span class="badge bg-warning subline-prefix me-2">
          {{ t("startPage.ctaBanner.simpleAndSecure.sublinePrefix") }}
        </span>
        {{ t("startPage.ctaBanner.simpleAndSecure.subline") }}
      </p>

      <CtaButton href="/users/sign_up">
        {{ t("startPage.ctaBanner.startFree") }}
      </CtaButton>
    </div>
  </CtaBanner>
</template>

<style lang="scss" scoped>
.cta-banner-simple-and-secure {
  &__image {
    width: 45%;
    @include media-breakpoint-down(md) {
      width: 100%;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: center;
    }
  }

  &__text {
    width: 55%;
    @include media-breakpoint-down(md) {
      width: 100%;
    }
  }

  &__title {
    color: $color-primary;
    font-size: $h1-font-size;
    font-weight: $font-weight-semibold;
    line-height: 2.5rem;
  }

  &__content {
    font-size: $font-size-base;
    line-height: 1.625rem;
  }

  .subline-prefix {
    vertical-align: text-bottom;
  }

  @include media-breakpoint-down(xl) {
    gap: $spacer-5;
    padding: $spacer-5;

    &__title {
      font-size: $h2-font-size;
    }
  }

  @include media-breakpoint-down(md) {
    padding: $spacer-4;
    gap: $spacer-4;

    &__title {
      font-size: $h3-font-size;
      line-height: 2rem;
    }
  }

  @include media-breakpoint-up(md) {
    flex-direction: row-reverse;
  }
}
</style>
